import { takeEvery, takeLatest,fork, put, all, call } from "redux-saga/effects";
import axios from 'axios';
import { GET_CUSTOM_ART_LIST, POST_CUSTOM_ART } from "./actionTypes";
import { listCustomArtFail, listCustomArtSuccess, postCustomArtFail, postCustomArtSuccess } from "./actions";
import { listCustomArtApi, postCustomArtApi } from "helpers/backend_helper";




function* postCustomArt({ payload: { data, callback } }) {
  try {
    // console.log("apylaod", payload)
    console.log("fasdfasdfasdf", data)
    const response = yield call(postCustomArtApi, data);
    callback && callback(response);
    if (response.status === "failure") {
       yield put(postCustomArtFail(response.message));
    }
    yield put(postCustomArtSuccess(response))
  } catch (error) {
    yield put(postCustomArtFail(error));
  }
}


function* listCustomArt({ payload: { data, callback } }) {
    try {
      const response = yield call(listCustomArtApi, data);
      if (response.status === "failure") {
         yield put(listCustomArtFail(response.message));
      }
      yield put(listCustomArtSuccess(response.data))
      callback && callback(response);
    } catch (error) {
      yield put(listCustomArtFail(error));
    }
  }

function* CustomPrintSaga() {
  yield takeEvery(POST_CUSTOM_ART, postCustomArt);
  yield takeEvery(GET_CUSTOM_ART_LIST, listCustomArt);
}


export default CustomPrintSaga;